import axios from "axios";
const API_URL = process.env.REACT_APP_API_URL;
const auth = () => ({
  Authorization: `Bearer ${localStorage.getItem("token")}`,
});

// Obtener documentos por tarea
export const getDocumentosByTarea = async (id_Tarea) => {
  const res = await axios.get(`${API_URL}/api/documentosTareas/${id_Tarea}`, {
    headers: auth(),
  });
  return res.data;
};

// Subir documento
export const uploadDocumentoTarea = async (
  file,
  id_Tarea,
  tipoDocumento,
  fechaCaducidad
) => {
  const formData = new FormData();
  formData.append("file", file);
  formData.append("id_Tarea", id_Tarea);
  formData.append("TipoDocumento", tipoDocumento);
  if (fechaCaducidad) formData.append("FechaCaducidad", fechaCaducidad);

  const res = await axios.post(
    `${API_URL}/api/documentosTareas/upload`,
    formData,
    {
      headers: { ...auth(), "Content-Type": "multipart/form-data" },
    }
  );
  return res.data;
};

// Eliminar documento
export const deleteDocumentoTarea = async (id_Documento) => {
  const res = await axios.delete(
    `${API_URL}/api/documentosTareas/${id_Documento}`,
    {
      headers: auth(),
    }
  );
  return res.data;
};
